// extracted by mini-css-extract-plugin
export default {"root":"FileDirection__root--1mZVP","folder":"FileDirection__folder--kLzIe","dots":"FileDirection__dots--dQf2H","directionIcon":"FileDirection__directionIcon--3GInK"};